module.exports = __webpack_public_path__ + "img/30.48450cd9.png";